<input type="text" class="form-control date-select-div"
                ngxDaterangepickerMd
                [(ngModel)]="selected"
                
                [showCustomRangeLabel]="true"
                [ranges]="ranges"
                [linkedCalendars]="true"
                placeholder="&#xf073;"/>
